import Dialog from './Dialog'

import ImageDialog from './ImageDialog'

export {
  Dialog,
  ImageDialog
}